import BaseApi from "@/core/HttpResources/BaseApi";
import SendedPorposal from "@/models/porposal/sendedPorposal.Model";
export default class PorposalService {
  baseApiPublish = new BaseApi("Coins");
  async getCoins(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAll",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}